<template>
    <div class='flex h-full qk-sxpris-view' style='overflow: auto'>
        <div class='flex h-full tep-tree__container'>
            <ai-tree-list-edit
                ref='treeRef'
                :meta="treeMeta"
                :to-remove-toolbar-items-names="removeTreeToolbarBtns"
                @cell-click='onTreeCellClick'
                @toolbar-button-click="onToolbarClickTree"
                @insert-save="insertSave"
                @user-data-changed='onUserDataChanged'
                @treeListEditMounted="treeListEditMounted"
                @changesSavedSuccessfully="changesSavedSuccessfully"
                @refreshEnd="onRefreshEnd"
            >
            </ai-tree-list-edit>
        </div>
        <div class='h-full flex flex-col w-full'>
            <div class="tep-header-block">
                <div class='tep-header-item w-full flex dx-field'>
                    <div class='tep-header-label'>Краткое наименование</div>
                    <div class="tep-header-input">
                        <ai-text-box
                            :value='shortNameTree'
                            @input='(data) => onTreeDataChange("name", data.newText)'
                        ></ai-text-box>
                    </div>
                </div>
                <div class='tep-header-item w-full flex dx-field'>
                    <div class='tep-header-label'>Полное наименование</div>
                    <div class="tep-header-input">
                        <ai-text-box
                            :value='nameTree'
                            @input='(data) => onTreeDataChange("wpotr", data.newText)'
                        ></ai-text-box>
                    </div>
                </div>
                <div class='tep-header-item w-full flex dx-field'>
                    <div class='tep-header-label'>Параметр измерения</div>
                    <div class="tep-header-input">
                        <ai-text-box
                            :value='paramTree'
                            @input='(data) => onTreeDataChange("param", data.newText)'
                        ></ai-text-box>
                    </div>
                </div>
            </div>
            <div class="tep-header-block">
                <div class="tep-header-title">Нормы расходы воды потребителями</div>
                <div class='tep-header-item w-full flex dx-field'>
                    <div class='tep-header-label'>Открытый водоразбор</div>
                    <div class="tep-header-number-input-wrapper">
                        <div class="tep-header-number-input">
                            <ai-number-box
                                :value='wsutoTree'
                                @input='(data) => onTreeDataChange("wsut_o", data.newText)'
                            ></ai-number-box>
                        </div>
                        <div class="tep-header-after-input">
                            Л/сутки
                        </div>
                    </div>
                    <div class="tep-header-number-input-wrapper">
                        <div class="tep-header-number-input">
                            <ai-number-box
                                :value='whoTree'
                                @input='(data) => onTreeDataChange("wh_o", data.newText)'
                            ></ai-number-box>
                        </div>
                        <div class="tep-header-after-input">
                            Л/час
                        </div>
                    </div>
                </div>
                <div class='tep-header-item w-full flex dx-field'>
                    <div class='tep-header-label'>Закрытый водоразбор</div>
                    <div class="tep-header-number-input-wrapper">
                        <div class="tep-header-number-input">
                            <ai-number-box
                                :value='wsutzTree'
                                @input='(data) => onTreeDataChange("wsut_z", data.newText)'
                            ></ai-number-box>
                        </div>
                        <div class="tep-header-after-input">
                            Л/сутки
                        </div>
                    </div>
                    <div class="tep-header-number-input-wrapper">
                        <div class="tep-header-number-input">
                            <ai-number-box
                                :value='whzTree'
                                @input='(data) => onTreeDataChange("wh_z", data.newText)'
                            ></ai-number-box>
                        </div>
                        <div class="tep-header-after-input">
                            Л/час
                        </div>
                    </div>
                </div>
            </div>
            <div class="tep-header-block">
                <div class="tep-header-title">Расход воды прибором</div>
                <div class='tep-header-item w-full flex dx-field'>
                    <div class='tep-header-label'></div>
                    <div class="tep-header-number-input-wrapper">
                        <div class="tep-header-number-input">
                            <ai-number-box
                                :value='prsecTree'
                                @input='(data) => onTreeDataChange("pr_sec", data.newText)'
                            ></ai-number-box>
                        </div>
                        <div class="tep-header-after-input">
                            Л/сек
                        </div>
                    </div>
                    <div class="tep-header-number-input-wrapper">
                        <div class="tep-header-number-input">
                            <ai-number-box
                                :value='prhTree'
                                @input='(data) => onTreeDataChange("pr_h", data.newText)'
                            ></ai-number-box>
                        </div>
                        <div class="tep-header-after-input">
                            Л/час
                        </div>
                    </div>
                </div>
            </div>
            <div class="tep-header-block">
                <div class="tep-header-title">Нормы расхода воды сантехническими приборами</div>
                <div class='tep-header-item w-full flex dx-field'>
                    <div class='tep-header-label'>Открытый водоразбор</div>
                      <div class="tep-header-number-input-wrapper">
                        <div class="tep-header-number-input">
                            <ai-number-box
                                :value='prhoTree'
                                @input='(data) => onTreeDataChange("pr_h_o", data.newText)'
                            ></ai-number-box>
                        </div>
                        <div class="tep-header-after-input">
                            Л/час
                        </div>
                    </div>
                </div>
                <div class='tep-header-item w-full flex dx-field'>
                    <div class='tep-header-label'>Закрытый водоразбор</div>
                    <div class="tep-header-number-input-wrapper">
                        <div class="tep-header-number-input">
                            <ai-number-box
                                :value='prhzTree'
                                @input='(data) => onTreeDataChange("pr_h_z", data.newText)'
                            ></ai-number-box>
                        </div>
                        <div class="tep-header-after-input">
                            Л/час
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'ds-nrasx-view',
};
</script>
<script setup>
import { onMounted, ref } from 'vue';
import AiTreeListEdit from '@/components/ai-tree-list-edit/ai-tree-list-edit.vue';
import AiTextBox from '@/components/ai-text-box.vue';
import AiNumberBox from '@/components/ai-number-box.vue';

const treeRef = ref(null);
const selectedKod = ref(null);
// Inputs start
const shortNameTree = ref(null);
const nameTree = ref(null);
const paramTree = ref(null);
const wsutoTree = ref(null);
const whoTree = ref(null);
const wsutzTree = ref(null);
const whzTree = ref(null);
const prsecTree = ref(null);
const prhTree = ref(null);
const prhoTree = ref(null);
const prhzTree = ref(null);
// Inputs finish
const dataTree = ref(null);
const treeInstance = ref(null);
const btnToolbar = ref(null);

onMounted(async() => {
    await treeRef.value?.setDataSource();
    await onStart();
});

const onStart = async (keySelect = null) => {
    let keySelectTreeFocus = keySelect;
    dataTree.value = await treeRef.value?.getTreeListDataSource();
    const keySelectInTree = dataTree.value.some(i => i.kod_nrasx === keySelect);
    if(!keySelectTreeFocus || !keySelectInTree) {
        keySelectTreeFocus = dataTree.value?.length ? dataTree.value[0].kod_nrasx : null;
    }
    selectedKod.value = keySelectTreeFocus;
    await treeRef.value?.treeListInstance.option('focusedRowKey', keySelectTreeFocus);
    await getNameFields();
};

const treeListEditMounted = async () => {
    treeInstance.value = treeRef?.value.treeListInstance;
};

const getNameFields = async () => {
    shortNameTree.value = await treeValue('name');
    nameTree.value = await treeValue('wpotr');
    paramTree.value = await treeValue('param');
    wsutoTree.value = await treeValue('wsut_o');
    whoTree.value = await treeValue('wh_o');
    wsutzTree.value = await treeValue('wsut_z');
    whzTree.value = await treeValue('wh_z');
    prsecTree.value = await treeValue('pr_sec');
    prhTree.value = await treeValue('pr_h');
    prhoTree.value = await treeValue('pr_h_o');
    prhzTree.value = await treeValue('pr_h_z');

};

const clearNameFields = () => {
    shortNameTree.value = null;
    nameTree.value = null;
    paramTree.value = null;
    wsutoTree.value = null;
    whoTree.value = null;
    wsutzTree.value = null;
    whzTree.value = null;
    prsecTree.value = null;
    prhTree.value = null;
    prhoTree.value = null;
    prhzTree.value = null;
}

const treeValue = (field) => {
    const rowData = dataTree.value?.find(el => el.kod_nrasx === selectedKod.value);
    return rowData ? rowData[field] : null
};

const onTreeCellClick = async (event, newEl = false) => {
    const buttonsRefs = await treeRef.value?.getButtonsRefs();
    if(!buttonsRefs.value['isSaveButtonDisabled']  && !newEl && selectedKod.value !== event.key) {
        const checkT = await checkTree();
        if(!checkT) return;

    }
    selectedKod.value = event.key;
    await buttonsStateChangeDisabled(false);
    await getNameFields();
};

const checkTree = async () => {
    await treeRef.value.treeListInstance.clearSelection();
    let canClose = await treeRef.value?.checkBeforeClose();
    return canClose;
};

const onToolbarClickTree = async(event) => {
    const name = event?.item?.component?.name
    btnToolbar.value = name;
};

const changesSavedSuccessfully = async() => {
    if(btnToolbar.value === 'delete') {
        await onStart();
    }
    btnToolbar.value = null;
}

const onTreeDataChange = async(field, textData) => {
    const instance = await treeRef.value?.treeListInstance;
    if (!instance) return;
    const focusedRowKey = await instance.option('focusedRowKey');
    if (focusedRowKey != null) {
        const focusedRowIndex = instance.getRowIndexByKey(focusedRowKey);
        instance.cellValue(focusedRowIndex, field, textData);
        await buttonsStateChangeDisabled(true)
    }
};

const buttonsStateChangeDisabled = async (status) => {
    const buttonsRefs = await treeRef.value?.getButtonsRefs();
    buttonsRefs.value['isAddChildButtonDisabled'] = status;
    buttonsRefs.value['isAddSiblingButtonDisabled'] = status;
    buttonsRefs.value['isDeleteButtonDisabled'] = status;
};

const insertSave = async (insert) => {
    if(insert?.responses?.length) {
        await buttonsStateChangeDisabled(false);
        dataTree.value = await treeRef.value?.getTreeListDataSource();
        if(insert?.responses[0].id) {
            selectedKod.value = insert?.responses[0].id;
            await onStart(selectedKod.value);
        }
    }
};

const onUserDataChanged = async (userData) => {
    const insertData = userData.treeListChanges?.filter(el => el.type === 'insert') ?? [];
    if(insertData?.length) {
        const itemNew = insertData[0];
        await onTreeCellClick(itemNew, true)
        dataTree.value = await treeRef.value?.getTreeListDataSource();
        await treeRef.value?.treeListInstance.option('focusedRowKey', itemNew.key);
    }
};

const onRefreshEnd = async () => {
    if(btnToolbar.value === 'refresh') {
        clearNameFields();
        await treeRef.value?.setFocusdRow(selectedKod.value);
        await onStart(selectedKod.value);
    }
}


const removeTreeToolbarBtns = ['choice', 'find-prev', 'find', 'find-start', 'find-next', 'expandOrCollapseButton',
    'copy', 'moveTo', 'moveSave', 'edit', 'searchPanel', 'export', 'show-column-chooser','cut', 'put'];

const treeMeta = {
    "keyExpr": "kod_nrasx",
    "columns": [
        {
            "name":"kod_nrasx",
            "caption":"Код",
            "dataField":"kod_nrasx",
            "allowEditing": false,
            "width":250,
            "index":1,
            "visible":false
        },
        {
            "name":"kod_r",
            "caption":"kod_r",
            "dataField":"kod_r",
            "allowEditing":false,
            "width":250,
            "index":2,
            "visible":false
        },
        {
            "name":"name",
            "caption":"Краткое наименование",
            "dataField":"name",
            "allowEditing":false,
            "width":'100%',
            "index":3,
            "visible":true
        },
        {
            "name":"wpotr",
            "caption":"Полное наименование",
            "dataField":"wpotr",
            "allowEditing":false,
            "width":250,
            "index":4,
            "visible":false
        },
        {
            "name":"param",
            "caption":"Параметр измерения",
            "dataField":"param",
            "allowEditing":false,
            "width":250,
            "index":5,
            "visible":false
        },
        {
            "name":"wsut_o",
            "caption":"Открытый водоразбор сутки",
            "dataField":"wsut_o",
            "allowEditing":false,
            "width":250,
            "index":6,
            "visible":false
        },
        {
            "name":"wh_o",
            "caption":"Открытый водоразбор час",
            "dataField":"wh_o",
            "allowEditing":false,
            "width":250,
            "index":7,
            "visible":false
        },
        {
            "name":"wsut_z",
            "caption":"Закрытый водоразбор сутки",
            "dataField":"wsut_z",
            "allowEditing":false,
            "width":250,
            "index":8,
            "visible":false
        },
        {
            "name":"wh_z",
            "caption":"Закрытый водоразбор час",
            "dataField":"wh_z",
            "allowEditing":false,
            "width":250,
            "index":9,
            "visible":false
        },
        {
            "name":"pr_sec",
            "caption":"Расход воды сек",
            "dataField":"pr_sec",
            "allowEditing":false,
            "width":250,
            "index":10,
            "visible":false
        },
        {
            "name":"pr_h",
            "caption":"Расход воды час",
            "dataField":"pr_h",
            "allowEditing":false,
            "width":250,
            "index":11,
            "visible":false
        },
        {
            "name":"pr_h_o",
            "caption":"Нормы расходы воды (открытый водоразбор)",
            "dataField":"pr_h_o",
            "allowEditing":false,
            "width":250,
            "index":12,
            "visible":false
        },
        {
            "name":"pr_h_z",
            "caption":"Нормы расходы воды (закрытый водоразбор)",
            "dataField":"pr_h_z",
            "allowEditing":false,
            "width":250,
            "index":13,
            "visible":false
        },
    ],
    "api":{
        "select":"tep-nsi./tep-nsi/ds-nrasx/select/get",
        "save":"tep-nsi./tep-nsi/ds-nrasx/save/set"
    },
    "viewId":"ds-nrasx-view",
    "parentIdExpr":"kod_r",
    'findTool':'filter',
    'selectButtonMode':'single',
    'selectionMode':'single',
    'maxWidth':'w-full',
    'wordWrapEnabled':true,
    'allowColumnResizing':false,
};
</script>
<style scoped>
.tep-tree__container {
    flex: 0 0 500px;
    margin-right: 20px;
}

.tep-header-block + .tep-header-block {
    margin-top: 20px;
    padding-top: 20px;
    border-top: 1px solid #ddd;
}

.tep-header-title {
    font-weight: 500;
    font-size: 16px;
    margin-bottom: 10px;
}

.tep-header-item {
    align-items: center;
}

.tep-header-label {
    width: 200px;
    padding-right: 8px;
}

.tep-header-input {
    width: 100%;
}

:root .tep-header-input :deep(.dx-field-value) {
    width: 100%;
}

.tep-header-number-input-wrapper {
    display: flex;
    align-items: center;
    gap: 8px;
}
.tep-header-number-input-wrapper + .tep-header-number-input-wrapper {
    margin-left: 24px;
}

.tep-header-after-input {
    min-width: 60px;
}
</style>
